import { TypeKeys, WidgetBlockAction } from './types';

type LoadingDataAction = WidgetBlockAction<TypeKeys.LOADING_DATA>;

const loadingWidgetData = (widgetId: string | null, instanceId: string | null): LoadingDataAction => ({
    type: TypeKeys.LOADING_DATA,
    payload: {
        widgetId,
        instanceId,
    },
});

export default loadingWidgetData;
export { LoadingDataAction };
